import Vue from 'vue'
import Vuex from 'vuex'
import {userService} from "@/services/user";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    requestLoading: false,
    routerLoading: false,
    //v3首页
    v3IndexCurrentTabIndex: 0,
    v3IndexTabs: [],
    v3IndexCurrentTabInfo: {},
    // 乳腺中心首页
    rxzxIndexCurrentTabIndex: 0,
    rxzxIndexTabs: [],
    rxzxIndexInfo: {},
    // 康复中心首页
    kfzxIndexCurrentTabIndex: 0,
    kfzxIndexTabs: [],
    kfzxIndexInfo: {},
    // 就诊人
    compatList: [],
    currentCompatIndex: -1,
  },
  mutations: {
    setRequestLoading(state, payload) {
      state.requestLoading = payload
    },
    setRouterLoading(state, payload) {
      state.routerLoading = payload;
    },
    //v3首页
    setV3IndexCurrentTabIndex(state, payload) {
      state.v3IndexCurrentTabIndex = payload;
    },
    setV3IndexTabs(state, payload) {
      state.v3IndexTabs = payload;
    },
    setV3IndexCurrentTabInfo(state, payload) {
      state.v3IndexCurrentTabInfo = payload;
    },
    //乳腺中心
    setRxzxIndexCurrentTabIndex(state, payload) {
      state.rxzxIndexCurrentTabIndex = payload;
    },
    setRxzxIndexTabs(state, payload) {
      state.rxzxIndexTabs = payload;
    },
    setRxzxIndexInfo(state, payload) {
      state.rxzxIndexInfo = payload;
    },
    //康复中心
    setKfzxIndexCurrentTabIndex(state, payload) {
      state.kfzxIndexCurrentTabIndex = payload;
    },
    setKfzxIndexTabs(state, payload) {
      state.kfzxIndexTabs = payload;
    },
    setKfzxIndexInfo(state, payload) {
      state.kfzxIndexInfo = payload;
    },
    // 常用就诊人
    setCompatList(state, payload) {
      state.compatList = payload;
    },
    setCurrentCompatIndex(state, payload) {
      state.currentCompatIndex = payload;
    }
  },
  actions: {
    async getCompatList(context) {
      const list = await userService.compatList();
      context.commit('setCompatList', list);
      return list;
    }
  }
})


export default store;



// WEBPACK FOOTER //
// ./src/store/index.js